import momentTimezone from 'moment-timezone'
import BigNumber from "bignumber.js";
import { Message } from 'iview'
import i18n from '@/lang/il8n'

const utils = {
  formatPryAmount(amount, fixedLength = 8) {
    if (!amount) {
      return '0.00';
    }
    let formattedAmount = parseFloat(amount).toFixed(fixedLength); // 将金额转为保留8位小数的字符串
    if (formattedAmount === '0'.repeat(fixedLength)) {
      return '0.00'; // 如果位数都是0，则返回 0.00
    }
    formattedAmount = formattedAmount.replace(/0+$/, ''); // 去除末尾多余的0
    const decimalIndex = formattedAmount.indexOf('.'); // 获取小数点位置
    if (decimalIndex !== -1) {
      const decimalPart = formattedAmount.slice(decimalIndex + 1); // 获取小数部分
      if (decimalPart.length < 2) {
        formattedAmount = formattedAmount.padEnd(decimalIndex + 3, '0'); // 不足两位小数补0
      }
    } else {
      formattedAmount += '.00'; // 如果没有小数部分，则补充两位小数
    }
    return formattedAmount;
  },
  formatPryAmount1(formattedAmount, fixedLength = 8) {
    if (!formattedAmount || formattedAmount == '0') {
      return '0.00';
    }

    formattedAmount = formattedAmount.replace(/0+$/, ''); // 去除末尾多余的0
    const decimalIndex = formattedAmount.indexOf('.'); // 获取小数点位置

    if (decimalIndex !== -1) {
      const decimalPart = formattedAmount.slice(decimalIndex + 1); // 获取小数部分
      if (decimalPart.length < 2) {
        formattedAmount = formattedAmount.padEnd(decimalIndex + 3, '0'); // 不足两位小数补0
      }
    } else {
      formattedAmount += '.00'; // 如果没有小数部分，则补充两位小数
    }
    return formattedAmount;
  },

  formatPryClosePrice(amount) {
    if (!amount) {
      return '--';
    }
    let formattedAmount = parseFloat(amount).toFixed(8); // 将金额转为保留8位小数的字符串
    if (formattedAmount === '0'.repeat(8)) {
      return '0.00'; // 如果位数都是0，则返回 0.00
    }
    formattedAmount = formattedAmount.replace(/0+$/, ''); // 去除末尾多余的0
    const decimalIndex = formattedAmount.indexOf('.'); // 获取小数点位置
    if (decimalIndex !== -1) {
      const decimalPart = formattedAmount.slice(decimalIndex + 1); // 获取小数部分
      if (decimalPart.length < 2) {
        formattedAmount = formattedAmount.padEnd(decimalIndex + 3, '0'); // 不足两位小数补0
      }
    } else {
      formattedAmount += '.00'; // 如果没有小数部分，则补充两位小数
    }
    return formattedAmount;
  },
  /**
   * usdt转美元
   * @param Number usdt_price
   * @param Number rate
   * @param Number fixedLength 保留小数位数
   */
  usdtToUsd(usdt_price, rate, fixedLength = 3) {
    let num = parseFloat(usdt_price) * rate
    num === 'NaN' && (num = 0)
    fixedLength && (num = num.toFixed(fixedLength))
    return num
  },
  /**
   * 价格单位转换
   * @param Number price 价格
   * @param Number fixedLength 保留小数位数
   */
  priceToShort(price, fixedLength = 2) {
    price = parseFloat(price)
    if (price >= 1000000) {
      price = price / 1000000
      price = price.toFixed(fixedLength)
      price += 'M'
    } else {
      return price.toFixed(fixedLength)
    }
    return price
  },
  /**
   * 保留有效数字
   * @param Number num 数字
   * @param Number fixedLength 保留小数位数
   */
  numberToFixed(num, fixedLength) {
    if (!num) {
      return '';
    }
    num = parseFloat(num)
    num === 'NaN' && (num = 0)
    fixedLength && (num = num.toFixed(fixedLength))
    return num
  },
  numberToFixed1(num, fixedLength) {
    if (!num) {
      return '';
    }
    num = parseFloat(num)
    num === 'NaN' && (num = 0)
    fixedLength && (num = num.toFixed(fixedLength))
    return num == '0.00' ? '999' : num
  },
  /**
   * 转化为本地时间
   * @param String time 时间
   * @param String format 格式
   * @param String timeZone 时区
   */
  toLocalTime(time, format = 'YYYY-MM-DD HH:mm:ss', timeZone = 'Australia/Sydney') {
    return momentTimezone
      .tz(time, timeZone)
      .local()
      .format(format)
  },

  toLocalTimeIntl(time, format = 'YYYY-MM-DD HH:mm:ss', timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone) {
    const originalTimezone = 'Australia/Sydney';
    const originalMoment = momentTimezone.tz(time, originalTimezone);
    const convertedMoment = originalMoment.clone().tz(timeZone);
    // 格式化转换后的时间
    const convertedTime = convertedMoment.local().format(format);
    return convertedTime
  },
  // 复制文本
  onCopy(text) {
    let input = document.createElement('input')
    input.value = text
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
    Message.success(i18n.t('Copy succeeded'))
  },
  // 数字补0
  addZero(i) {
    return i < 10 ? '0' + i : i + ''
  },
  // 倒计时
  countDown(endTime, beginTime = Date.now()) {
    var leftTime = parseInt((endTime - beginTime) / 1000)
    if (leftTime <= 0) {
      return ''
    }
    var d = parseInt(leftTime / (24 * 60 * 60))
    var h = parseInt((leftTime / (60 * 60)) % 24)
    var m = parseInt((leftTime / 60) % 60)
    var s = parseInt(leftTime % 60)
    h = utils.addZero(h)
    m = utils.addZero(m)
    s = utils.addZero(s)
    return `${d > 0 ? d + i18n.t('Day') + ' ' : ''}${h}:${m}:${s}`
  }
}

utils.getQueryString = getQueryString

/**
 * 获取url中的参数
 * @param url 完整链接
 * @param name 参数名
 */
export function getQueryString(url, name) {
  if (!url) {
    return null
  }
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = url.split('?')[1]
  r = r ? r.match(reg) : null
  return r != null ? decodeURI(r[2]) : null
}
// 防抖debounce代码：
export function debounce(fn, delay) {
  let timeout = null // 创建一个标记用来存放定时器的返回值
  return function (e) {
    // 每当用户输入的时候把前一个 setTimeout clear 掉
    clearTimeout(timeout)
    // 然后又创建一个新的 setTimeout, 这样就能保证interval 间隔内如果时间持续触发，就不会执行 fn 函数
    timeout = setTimeout(() => {
      fn.apply(this, arguments)
      timeout = null
    }, delay)
  }
}


export default {
  install: function (Vue) {
    Vue.prototype.$utils = utils
  }
}

// 保留小数点后N位,下取整，自动补0，变成string
export function toDecimal2(x, num = 2) {
  var n = new BigNumber(x);
  var c = n.toFixed(num, 1);
  return c;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js